// pages/emailid-update-user/index.js

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { updateUserPassword } from "./actions";
import UpdateUserPassword from "./component";

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateUserPasswordConnect: updateUserPassword,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUserPassword);
